/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { observer } from "mobx-react-lite"
import { Outlet, useLocation, useNavigation } from "react-router"

import { SessionViewModel } from "../../features/session/session-view-model"
import { isPublicRoute } from "../../utils/is-public-route"
import { Toaster } from "../primitives/toast"
import { SidebarView } from "../sidebar/sidebar-view"
import { FullscreenSpinner } from "../ui-widgets/loading/spinner"
import { useViewModel } from "./app-hooks"

export const AppLayout = observer(() => {
    const navigation = useNavigation()
    const location = useLocation()
    const session = useViewModel(SessionViewModel)

    if (navigation.state === "loading") {
        return <FullscreenSpinner />
    }

    const showSidebar = session.hasUser && !isPublicRoute(location.pathname)

    return (
        <>
            {showSidebar && <SidebarView />}
            <div id="main">
                {/* Render the active child route here. */}
                <Outlet />
            </div>
            {/* Keep the Toaster at the shell level so every route can use the same toast manager. */}
            <Toaster />
        </>
    )
})
